import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { BRAND_IMAGES, getBrandImageUrl } from '@/app/common/contentHubAssets.ts';
import { Icon } from '@/app/common/icons/Icon';
import {
  TaxesIncludedTooltipCaret,
  TaxesIncludedTooltipCloseButton,
  TaxesIncludedTooltipContent,
  TaxesIncludedTooltipImage,
  TaxesIncludedTooltipInner,
  TaxesIncludedTooltipText,
  TaxesIncludedTooltipTextContainer,
  TaxesIncludedTooltipWrapper,
} from './styled';

type TaxesIncludedTooltipProps = {
  onDismiss: () => void;
};

const TaxesIncludedTooltip = ({ onDismiss }: TaxesIncludedTooltipProps) => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();

  const image = getBrandImageUrl(BRAND_IMAGES.DEPOSIT, localization);

  return (
    <TaxesIncludedTooltipWrapper role="tooltip">
      <TaxesIncludedTooltipCaret viewBox="0 0 32 14" aria-hidden="true">
        {/* Open path: SVG implicitly closes for fill (covers card border at base)
            but only strokes the two slanted edges drawn by M-L-L. */}
        {/* Cubic Bezier at the peak matches the Figma mockup's curve.
            Slant endpoints extended to the canvas bottom corners so the
            (un-closed) path's fill covers the card's top border under
            the caret base — the implicit fill close runs along the
            canvas bottom edge. */}
        <path d="M0.5 14 L12.582 1.916 C14.47 0.028 17.53 0.028 19.418 1.916 L31.5 14" />
      </TaxesIncludedTooltipCaret>
      <TaxesIncludedTooltipContent>
        <TaxesIncludedTooltipInner>
          <TaxesIncludedTooltipImage src={image} alt="" />
          <TaxesIncludedTooltipTextContainer>
            <TaxesIncludedTooltipText $weight="bold">
              {t('vacation.oss.taxes_included.tooltip.text1')}
            </TaxesIncludedTooltipText>
            <TaxesIncludedTooltipText>{t('vacation.oss.taxes_included.tooltip.text2')}</TaxesIncludedTooltipText>
          </TaxesIncludedTooltipTextContainer>
        </TaxesIncludedTooltipInner>
        <TaxesIncludedTooltipCloseButton
          type="button"
          aria-label={t('vacation.oss.cards.map.close')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDismiss();
          }}
        >
          <Icon category="Semantics" name="icon-cross" size={20} color="iconPrimary" alt="" />
        </TaxesIncludedTooltipCloseButton>
      </TaxesIncludedTooltipContent>
    </TaxesIncludedTooltipWrapper>
  );
};

export default TaxesIncludedTooltip;
